import React, { useEffect, useState } from 'react';
import FsTabPanel from 'ui-elements/tabs/FsTabPanel';
import { Box, Fade } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useReportContext } from 'contexts/report/ReportContext';

const ReportMainTabsSection: React.FC = () => {
  const {
    report: { accountTypes, setActiveAccountType },
  } = useReportContext();

  const [idx, setIdx] = useState<number>(0);
  const [isChanged, setIsChanges] = React.useState<boolean>(false);

  const handleChange = (
    event: React.ChangeEvent<Record<string, unknown>>,
    newIdx: number
  ): void => {
    setIdx(newIdx);
    setIsChanges(true);
  };

  useEffect(() => {
    if (isChanged) setActiveAccountType(accountTypes[idx]);
  }, [accountTypes, idx, isChanged, setActiveAccountType]);

  return (
    <Fade in timeout={1000}>
      <Box data-test="report-main-tabs-section-component">
        <FsTabPanel labels={accountTypes} onChange={handleChange} value={idx} />
      </Box>
    </Fade>
  );
};

ReportMainTabsSection.displayName = 'ReportMainTabsSection';

export default observer(ReportMainTabsSection);
